exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}.sf-rating{display:-ms-flexbox;display:flex}.sf-rating__icon{--icon-color: var(--c-primary)}.sf-rating__icon--negative{--icon-color: var(--c-gray-variant)}\n", ""]);

// exports
